import locale7742780c from '../../lang/en-US'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en"},
  vueI18nLoader: false,
  locales: [{"code":"en","iso":"en-US","file":"en-US","name":"English (US)"},{"code":"cn","iso":"zh-CN","file":"zh-CN","name":"Chinese (Simplified)"},{"code":"jp","iso":"ja","file":"ja","name":"Japanese"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_and_default",
  lazy: true,
  langDir: "/home/runner/work/marketing/marketing/lang",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "https://procreate.art",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","iso":"en-US","file":"en-US","name":"English (US)"},{"code":"cn","iso":"zh-CN","file":"zh-CN","name":"Chinese (Simplified)"},{"code":"jp","iso":"ja","file":"ja","name":"Japanese"}],
  localeCodes: ["en","cn","jp"],
}

export const localeMessages = {
  'en-US': () => Promise.resolve(locale7742780c),
  'zh-CN': () => import('../../lang/zh-CN' /* webpackChunkName: "lang-zh-CN" */),
  'ja': () => import('../../lang/ja' /* webpackChunkName: "lang-ja" */),
}
